/**
 * The validation rules for the resident demographics form.
 */
export const RESIDENT_DEMOGRAPHICS_RULES = {
    resident_demographics: {
        resident_firstName: ["required"],
        resident_lastName: ["required"],
        resident_gender: ["required"],
        resident_dateOfBirth: ["required"],
        resident_middleInitial: ["string", "max_length:1"],
    },
};
